import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import DragHandle from '~/images/forms/fields/drag.svg';

import Field from './Field';
import styles from './ListFields.style';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (draggableStyle) => ({
  userSelect: 'none',
  ...draggableStyle,
});

class ListFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: props.fields,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.fields) {
      this.setState({
        fields: props.fields,
      });
    }
  }

  onDragStart(start) {
    this.onSelectFieldIndex(start.source.index);
  }

  onDragEnd(result) {
    if (!result.destination) return;

    const fields = reorder(
      this.state.fields,
      result.source.index,
      result.destination.index,
    );

    this.setState({ fields }, () => {
      this.onSelectFieldIndex(result.destination.index);
      this.updateIndicies();
    });
  }

  updateIndicies() {
    const { fields } = this.state;
    this.props.onChange(fields);
  }

  onSelectFieldIndex(index) {
    this.props.onSelectFieldIndex(index);
  }

  renderField(field, index) {
    const { classes, selectedFieldIndex } = this.props;

    return (
      <Draggable key={field.id || index} draggableId={field.id} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={classes.draggable}
            style={getItemStyle(
              provided.draggableProps.style,
              snapshot.isDragging,
            )}
            {...provided.dragHandleProps}
            onClick={this.onSelectFieldIndex.bind(this, index)}>
            <Field
              key={field.id || index}
              field={field}
              isDragging={snapshot.isDragging}
              isSelected={index === selectedFieldIndex}
            />

            <div className={classes.dragHandle}>
              <DragHandle />
            </div>
          </div>
        )}
      </Draggable>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <DragDropContext
          onDragEnd={this.onDragEnd}
          onDragStart={this.onDragStart}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef}>
                {this.state.fields.map(this.renderField.bind(this))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }
}

ListFields.propTypes = {
  classes: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedFieldIndex: PropTypes.number.isRequired,
  onSelectFieldIndex: PropTypes.func.isRequired,
};

export default withStyles(styles)(ListFields);
